import "./styles/Card.css";
function Card({ pdf, pic }) {
  return (
    <>
      <div className="Card">
        <div className="card__content">
          <a target="__blank" href={pdf}>
            <img className="img-fluid" src={pic} alt="" />
          </a>
        </div>
      </div>
    </>
  );
}

export default Card;
